import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token = localStorage.getItem('tokenValue'); // or TokenService

    if (token) {
      req = req.clone({
        setHeaders: {
          Token: token, // 👈 use Token OR Authorization based on backend
          // Authorization: `Bearer ${token}`  // use this if backend expects Authorization
        }
      });
    }

    return next.handle(req);
  }
}